import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ligasInteres.css';
import {ligasInteres} from '../../json/ligasInteres';

const LigasInteres = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      return (
        
        <div className='container ligasInteres-container container-mh'>
        <div className='row'>
       <div className='col-12 mb-2'>
         <h3 className='title'>Ligas de Interés</h3>
         <hr className='hr-gob' />
         </div>
       </div>
    
          <div className='row'>
              <div className="col-12 col-md-4 col-lg-8 mb-3">
            {ligasInteres.map((item, index) => (
              <div key={index} className='liga-vertical-card mb-3'>
                <div className='-card shadow-sm p-13 h-100'>
                  <Link to={item.ligasInteres_url} className='liga-link vertical' target='_blank' rel='noopener noreferrer'>
                
                    {item.ligasInteres_nombre}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
        </div>
  )
}

export default LigasInteres